import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'
import { SnackBar } from 'builder/components/SnackBarV2'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'
import FutureLearn from '../futureLearn'
import { Container } from '../../components/Container'
import CategoryTabs from './components/CategoryTabs'
import { ProgressTracker } from './components/ProgressTracker'
import RecommendedJobs from './components/RecommendedJobs/RecommendedJobs'
import { CoachBanner } from './components/ResumeCoachBanner/CoachBanner'
import { ResumeWritingBanner } from './components/ResumeCoachBanner/ResumeWritingBanner'
import { DashboardContainer } from './components/ProgressTracker/styles'
import { Header } from './components/ProgressTracker/Header/Header'

/**
 * This is a temporary component to group all the new dashboard components
 * and features until we can refactor the entire dashboard.
 * It will probably be removed or refactored in the future.
 */

const BottomOffset = (props: { children: React.ReactNode }) => (
  <div style={{ marginBottom: '32px', width: '100%' }}>{props.children}</div>
)

const DashboardV4 = (props: { children: React.ReactNode }) => {
  const { features } = useFeaturesConfig()
  const [searchParams] = useSearchParams()

  const categoryTab = searchParams.get('categoryTab')

  useEffect(() => {
    if (categoryTab) {
      trackInternalEvent('visit_dashboard', { category: categoryTab })
    }
  }, [categoryTab])

  return (
    <Container>
      <CategoryTabs>
        <Header />
        <CategoryTabs.List>
          <CategoryTabs.Item tabId="resumes">Resume building</CategoryTabs.Item>
          <CategoryTabs.Item tabId="jobs">Job search</CategoryTabs.Item>
          <CategoryTabs.Item tabId="interview">Interview prep</CategoryTabs.Item>
          <CategoryTabs.Item tabId="learning">Learning</CategoryTabs.Item>
        </CategoryTabs.List>

        <DashboardContainer>
          <CategoryTabs.Content tabId="resumes">
            <ProgressTracker categoryId="resumes" />
          </CategoryTabs.Content>
          <CategoryTabs.Content tabId="jobs">
            <ProgressTracker categoryId="jobs" />
          </CategoryTabs.Content>
          <CategoryTabs.Content tabId="interview">
            <ProgressTracker categoryId="interview" />
          </CategoryTabs.Content>
          <CategoryTabs.Content tabId="learning">
            <ProgressTracker categoryId="learning" />
          </CategoryTabs.Content>

          {features?.learningHub && (
            <CategoryTabs.Content tabId="learning">
              <FutureLearn />
            </CategoryTabs.Content>
          )}

          <RecommendedJobs />

          {features?.learningHub && (
            <>
              <CategoryTabs.Content tabId="resumes">
                <FutureLearn />
              </CategoryTabs.Content>
              <CategoryTabs.Content tabId="jobs">
                <FutureLearn />
              </CategoryTabs.Content>
              <CategoryTabs.Content tabId="interview">
                <FutureLearn />
              </CategoryTabs.Content>
            </>
          )}

          {props.children}

          {features?.resumeWriting && (
            <CategoryTabs.Content tabId="resumes">
              <BottomOffset>
                <ResumeWritingBanner />
              </BottomOffset>
            </CategoryTabs.Content>
          )}

          {features?.careerCoaching && (
            <CategoryTabs.Content tabId="jobs">
              <BottomOffset>
                <CoachBanner />
              </BottomOffset>
            </CategoryTabs.Content>
          )}

          {features?.careerCoaching && (
            <CategoryTabs.Content tabId="interview">
              <BottomOffset>
                <CoachBanner />
              </BottomOffset>
            </CategoryTabs.Content>
          )}

          {features?.careerCoaching && (
            <CategoryTabs.Content tabId="learning">
              <BottomOffset>
                <CoachBanner />
              </BottomOffset>
            </CategoryTabs.Content>
          )}
        </DashboardContainer>
      </CategoryTabs>

      <SnackBar />
    </Container>
  )
}

export default DashboardV4
